import { isTouchDevice } from '../functions'
import $ from "jquery";
import {unlockBody} from "../utils";

// eslint-disable-next-line no-undef
const object = vnObject
const { __ } = wp.i18n

const headerSearchBox = (renderOptions, isFirstRender) => {
  const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions;
  const container = document.querySelector(widgetParams.container);

  if (isFirstRender) {
    // Ajouter le loader d'abord dans le container
    container.insertAdjacentHTML('beforeend', object.loader);

    // Créer le container global
    const outerContainer = document.createElement('div');
    outerContainer.className = 'container';

    // Créer le wrapper pour input
    const inputWrapper = document.createElement('div');
    inputWrapper.className = 'header-search__input-wrapper';

    // Input
    const input = document.createElement('input');
    input.type = 'search';
    input.className = 'js-algolia-search-input';
    input.placeholder = widgetParams.placeholder;

    input.addEventListener('input', (event) => {
      refine(event.target.value);
    });

    // Assembler la structure
    inputWrapper.appendChild(input);
    outerContainer.appendChild(inputWrapper);
    container.appendChild(outerContainer);
  }

  container.querySelector('input').value = query;
  container.querySelector('.vn-loader').hidden = !isSearchStalled;
};


export default headerSearchBox
